<template>
    <el-card shadow="never">
      <el-table
        :data="units"
        :loading="loading"
        style="width: 100%"
        v-loading.fullscreen.lock="loading"
        empty-text="No Data"
        >
        <el-table-column
            property="unit.name"
            label="Unit Name"
        >
        </el-table-column>
        <el-table-column
            label="Price"
            :width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.updatedPrice">
                {{ scope.row.updatedPrice | currencySign($root.state.facilityData) }} / month
              </span>
              <span v-else-if="scope.row.pricing">
                {{ scope.row.pricing.price | currencySign($root.state.facilityData) }} / month
              </span>
              <span v-else>
              -
              </span>
            </template>
        </el-table-column>
        <el-table-column
            label="Move In"
        >
            <template slot-scope="scope">
                <span>{{ scope.row.moveIn | formatDate }}</span>
            </template>
        </el-table-column>
        <el-table-column
            label="Move Out"
        >
            <template slot-scope="scope">
                <span v-if="scope.row.moveOut">{{ scope.row.moveOut | formatDate }}</span>
                <span v-else> - </span>
            </template>
        </el-table-column>
        <el-table-column
            property="unit.type"
            label="Unit kind">
        </el-table-column>
        <el-table-column
            label="Unit Size">
            <template slot-scope="scope">
                <span>{{ scope.row.unit.computedSize }} Sq ft.</span>
            </template>
        </el-table-column>
        <el-table-column
            label="Deposit"
        >
          <template slot-scope="scope">
            {{ scope.row.securityDeposit || getDepositValue(scope.row) | currencySign }}
          </template>
        </el-table-column>
        <el-table-column
            label="Status"
        >
        <template slot-scope="scope">
          <span v-if="!scope.row.completed"> {{ scope.row.unit.status | printableStatus }}</span>
          <span v-else> - </span>
        </template>
        </el-table-column>
        <el-table-column
            label="Finance"
        >
        <template slot-scope="scope">
          <span v-if="!scope.row.completed"> {{ scope.row.unit.leaseStatus | printableStatus }}</span>
          <span v-else> - </span>
        </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.completed" type="text" size="small" @click="() => openPriceForm(scope.row)">Edit</el-button>
            <el-button type="text" size="small" @click="() => routeToUnit(scope.row)">View</el-button>
          </template>
        </el-table-column>
    </el-table>
    <el-dialog id="rental" :visible.sync="dialogFormVisible" width="75%">
      <Lease
        v-if="dialogFormVisible"
        :with-header="false"
        :facility="facility"
        :id="selectedRental"
        @close="() => dialogFormVisible = false"
      />
    </el-dialog>
    <el-dialog id="rental-price" :visible.sync="dialogForm">
      <el-card shadow="never" :loading="loading">
        <template slot="header">
          The price change takes effect as of the next bill.
        </template>
        <el-form>
          <el-form-item label="New Price">
            <el-input-number v-model="price">
            </el-input-number>
          </el-form-item>
        </el-form>
        <el-button @click="savePrice">Save</el-button>
      </el-card>
    </el-dialog>
  </el-card>
</template>

<script>
import axios from 'axios';
import { UNIT_RENTAL_API_BASE } from '../env';
import Lease from './Lease.vue';

export default {
  name: 'CustomerUnits',
  components: { Lease },
  props: {
    id: { type: String, required: true },
    facility: { type: String, default: null },
  },
  async mounted() {
    await this.getUnits();
  },
  data() {
    return {
      units: [],
      loading: true,
      selectedRental: null,
      unitRental: null,
      dialogFormVisible: false,
      dialogForm: false,
      price: 0,
      search: '',
    };
  },
  watch: {
    async facility() {
      await this.getUnits();
    },
    async id() {
      await this.getUnits();
    },
  },
  methods: {
    openPriceForm(rental) {
      this.unitRental = rental;
      this.price = this.unitRental.updatedPrice ? this.unitRental.updatedPrice : this.unitRental.pricing.price;
      this.selectedRental = rental._id;
      this.dialogForm = true;
    },
    getDepositValue(rental) {
      const deposits = rental.lineItems.filter(item => item.details === 'DEPOSIT');
      return deposits.map(item => item.amount).reduce((p, n) => p + n, 0);
    },
    async getUnits() {
      try {
        this.loading = true;
        const units = await axios.get(`${UNIT_RENTAL_API_BASE}/customer/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          params: {
            limit: 250,
            ...(this.facility ? { facility: this.facility } : {}),
            ...(this.search ? { status: this.search } : {}),
          },
        });
        this.loading = false;
        this.units = units.data.result;
      } catch (err) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: err.response.data,
        });
      }
    },
    async savePrice() {
      // disabled as per KP, have to enable it later.
      // if (this.price < this.unitRental.pricing.price) {
      //   this.$message.warning({
      //     title: 'Not allowed',
      //     message: 'Unit price can not be less than the original pricing',
      //   });
      //   return;
      // }

      this.loading = true;
      await axios.put(`${UNIT_RENTAL_API_BASE}/update/pricing/${this.selectedRental}`, {
        updatedPrice: this.price,
        history: {
          changedAt: new Date(),
          changedBy: this.$keycloak.tokenParsed.email,
          amount: this.unitRental.updatedPrice ? this.unitRental.updatedPrice : this.unitRental.pricing.price,
        },
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.loading = false;
      this.dialogForm = false;
      await this.getUnits();
    },
    routeToUnit(row) {
      // eslint-disable-next-line no-underscore-dangle
      this.selectedRental = row._id;
      this.dialogFormVisible = true;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CustomerUnits.vue